export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-thumbnail-480-ebe0028b356f33c9ef92775fa66f8c58.png";